export default __webpack_public_path__ + "assets/front/scss/formulaire.52ddcaaa714e5b9a68d96710fbe669c0.css";